import { CreditCard, Calendar, Percent, Coins, CurrencyIcon } from 'lucide-react';

const DepositParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  depositTypes,
  capitalizationOptions,
  currencyOptions
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Сумма вклада */}
      <div>
        <label htmlFor="depositAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Coins className="w-4 h-4 mr-2 text-green-500" />
          Сумма вклада
        </label>
        <div className="relative">
          <input
            type="text"
            id="depositAmount"
            name="depositAmount"
            value={formData.depositAmount}
            onChange={handleInputChange}
            className={`form-input w-full pr-10 ${errors.depositAmount ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 dark:text-gray-400">
            {currencyOptions.find(c => c.id === formData.currency)?.symbol || '₽'}
          </span>
        </div>
        {errors.depositAmount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.depositAmount}
          </p>
        )}
      </div>

      {/* Срок вклада */}
      <div>
        <label htmlFor="depositTerm" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-green-500" />
          Срок вклада (месяцев)
        </label>
        <input
          type="text"
          id="depositTerm"
          name="depositTerm"
          value={formData.depositTerm}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.depositTerm ? 'input-error' : ''}`}
          placeholder="Введите срок"
        />
        {errors.depositTerm && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.depositTerm}
          </p>
        )}
      </div>

      {/* Валюта вклада */}
      <div>
        <label htmlFor="currency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CurrencyIcon className="w-4 h-4 mr-2 text-green-500" />
          Валюта вклада
        </label>
        <select
          id="currency"
          name="currency"
          value={formData.currency}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {currencyOptions.map((currency) => (
            <option key={currency.id} value={currency.id}>
              {currency.name} ({currency.symbol})
            </option>
          ))}
        </select>
      </div>

      {/* Тип вклада */}
      <div>
        <label htmlFor="depositType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Тип вклада
        </label>
        <select
          id="depositType"
          name="depositType"
          value={formData.depositType}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {depositTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name} ({type.defaultRate}%)
            </option>
          ))}
        </select>
      </div>

      {/* Процентная ставка */}
      <div>
        <label htmlFor="interestRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Percent className="w-4 h-4 mr-2 text-green-500" />
          Процентная ставка (% годовых)
        </label>
        <input
          type="text"
          id="interestRate"
          name="interestRate"
          value={formData.interestRate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.interestRate ? 'input-error' : ''}`}
          placeholder="Введите ставку"
        />
        {errors.interestRate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.interestRate}
          </p>
        )}
      </div>

      {/* Дата открытия вклада */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Дата открытия вклада
        </label>
        <input
          type="date"
          id="startDate"
          name="startDate"
          value={formData.startDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.startDate ? 'input-error' : ''}`}
        />
        {errors.startDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startDate}
          </p>
        )}
      </div>

      {/* Капитализация процентов */}
      <div className="col-span-full">
        <label htmlFor="capitalization" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Капитализация процентов
        </label>
        <select
          id="capitalization"
          name="capitalization"
          value={formData.capitalization}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.capitalization ? 'input-error' : ''}`}
        >
          {capitalizationOptions.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
        {errors.capitalization && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.capitalization}
          </p>
        )}
      </div>

      {/* Учитывать налог */}
      <div className="col-span-full mt-2">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="tax"
            checked={formData.tax}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Учитывать НДФЛ (13% на доход свыше необлагаемой суммы)
          </span>
        </label>
      </div>
    </div>
  );
};

export default DepositParametersSection;